import React, { useState } from "react";
import { FormattedMessage as FM, useIntl } from "react-intl";
import { Button, Form, Message } from "semantic-ui-react";

import IDate from "../../data/Date";
import ICreatePriestData, { NewCreatePriestData } from "../../data/priest/CreatePriestData";
import ICreatePriestResponse from "../../requests/response/CreatePriestResponse";
import BoldFM from "../../util/styledMessages/BoldFM";
import DateInput from "../DateInput";

interface ICreatePriestFormProps {
    priest: ICreatePriestData;
    response: ICreatePriestResponse | undefined;
    setPriest(priest: ICreatePriestData): void;
    asyncPost(): Promise<void>;
}

const CreatePriestForm: React.FC<ICreatePriestFormProps> = (props: ICreatePriestFormProps) => {
    const { priest, setPriest, response, asyncPost } = props;
    const { formatMessage } = useIntl();

    const [errorMsg, setErrorMsg] = useState(false);

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setPriest({ ...priest, [name]: value });
    };

    const dateChange = (newDate: IDate) => {
        setPriest({ ...priest, birthDate: newDate });
    };

    const handleSubmit = () => {
        if (priest.name === "" || priest.birthTown === "" || !priest.birthDate.year) {
            setErrorMsg(true);
        } else {
            setErrorMsg(false);
            asyncPost();
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            {response && (
                <Message negative>
                    <FM id={response.label} />
                </Message>
            )}
            {errorMsg && (
                <Message negative>
                    <FM id="formError.invalidOrEmpty" />
                </Message>
            )}
            <Form.Input label={formatMessage({ id: "profile.name" }) + " *"} name="name" onChange={handleChange} type="text" />
            <Form.Field>
                <BoldFM id="profile.birthDate" />
                <b> *</b>
                <DateInput changeDate={dateChange} date={priest.birthDate} />
            </Form.Field>
            <Form.Input label={formatMessage({ id: "profile.birthTown" }) + " *"} name="birthTown" onChange={handleChange} type="text" />
            <Form.Input label={formatMessage({ id: "profile.birthCounty" })} name="birthCounty" onChange={handleChange} type="text" />
            <Form.Input label={formatMessage({ id: "profile.diocese" })} name="diocese" onChange={handleChange} type="text" />
            <Form.Input label={formatMessage({ id: "profile.birthCountry" })} name="birthCountry" onChange={handleChange} type="text" />

            <Button className="ui violet button" type="submit">
                <FM id="insert.priest" />
            </Button>
            <Button className="ui button" onClick={() => setPriest(NewCreatePriestData)} type="reset">
                <FM id="general.reset" />
            </Button>
        </Form>
    );
};

export default CreatePriestForm;
